export default __webpack_public_path__ + "fc2815526ef4acf5427cc4d2cefe9855.woff";